import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListLiquidaciones from './Components/ListLiquidaciones';
import LiquidacionNew from './Components/LiquidacionNew';
import EditarLiquidacion from './Components/EditarLiquidacion';
import EditarLiquidacionBorrador from './Components/EditarLiquidacionBorrador';
import ActualizacionMasivaLiquidaciones from './Components/Excel/ActualizacionMasivaLiquidaciones';
import FeeNew from './Components/FeeNew';
import ComprobantesLiquidaciones from './Components/ComprobantesLiquidaciones';

export default class AdmLiquidaciones extends React.Component {
    render() {
        return (
            <div>
                <Routes>
                    <Route path="" element={<ListLiquidaciones />} />
                    <Route path="Nueva" element={<LiquidacionNew />} />
                    <Route path="Editar/:id/:idSeller" element={<EditarLiquidacion />} />
                    <Route path="EditarBorrador/:id/:idSeller" element={<EditarLiquidacionBorrador />} />
                    <Route path="ActualizacionMasiva" element={<ActualizacionMasivaLiquidaciones/>}/>
                    <Route path="NuevoFee" element={<FeeNew/>}/>
                    <Route path="Comprobantes" element={<ComprobantesLiquidaciones />} />
                </Routes>
            </div>
        );
    }
}